import { render } from "./ViewEmployeeReport.vue?vue&type=template&id=2cd4e878&scoped=true"
import script from "./ViewEmployeeReport.vue?vue&type=script&lang=js"
export * from "./ViewEmployeeReport.vue?vue&type=script&lang=js"

import "./ViewEmployeeReport.vue?vue&type=style&index=0&id=2cd4e878&lang=scss&scoped=true"

import exportComponent from "/opt/lampp/htdocs/gslhrm/v6061/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cd4e878"]])

export default __exports__